import { HelpIcon } from "@/frontend/SVGs/HelpIcon";
import { I18n } from "@/i18n/I18n";
import { BlockType } from "@/types/blockTypes";
import { useState } from "react";
import { Modal, OverlayTrigger, Tooltip, Button, Form } from "react-bootstrap";

export function CreateBlockModal(props: { setShowModal: (showModal: boolean) => void, saveBlock: (title: string, blockType: BlockType) => void, defaultTitle?: string, showTypeSelect?: boolean }) {
  const { setShowModal, saveBlock, defaultTitle, showTypeSelect } = props;
  const [title, setTitle] = useState(defaultTitle || '');
  const [blockType, setBlockType] = useState(BlockType.Container);
  const [error, setError] = useState<string | undefined>(undefined);

  const onChangeTitle = (value: string) => {
    setTitle(value);
    setError(undefined);
  };

  const onClick = () => {
    if (!title) {
      setError(I18n.get('requiredFieldError', { field: I18n.get('title') }));
      return;
    }
    saveBlock(title, blockType);
    setShowModal(false);
  };

  return (
    <Modal show onHide={() => setShowModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>{I18n.get('createBlock')}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column align-items-end">
        <form className='w-100'>
          <Form.Label>{I18n.get('title')}</Form.Label>
          <Form.Control
            aria-label={I18n.get('enterField', { field: I18n.get('title') })}
            value={title}
            isInvalid={!!error}
            type="text"
            onChange={(event) => onChangeTitle(event.target.value)}
          />
          <Form.Control.Feedback type="invalid">
            { error }
          </Form.Control.Feedback>
          { showTypeSelect && <>
            <Form.Label>
              <span className='d-flex align-items-center gap-2 pt-2'>
                {I18n.get('blockType')}
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>{I18n.get('blockTypeHelp')}</Tooltip>}
                >
                  <div><HelpIcon/></div>
                </OverlayTrigger>
              </span>
            </Form.Label>
            <select
              defaultValue={BlockType.Container}
              onChange={(event) =>setBlockType(event.target.value as BlockType)}
              id='blockType'
              className='form-select'
            >
              <option value={BlockType.Container}>{I18n.get('Container')}</option>
              <option value={BlockType.Operation}>{I18n.get('Operation')}</option>
            </select>
          </>}
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" aria-label={I18n.get('cancel')} onClick={() => setShowModal(false)}>
          {I18n.get('cancel')}
        </Button>
        <Button variant="primary" aria-label={I18n.get('confirm')} onClick={onClick}>
          {I18n.get('confirm')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
